import axios from 'axios';
import store from '@/store';
import sessionService from '@/services/sessionService';

const apiPath = `${store.state.apiPathWithVersion}/register`;

export default {
  async enroll(params) {
    let apiUrl = store.state.countrySelected.api;
    params.lang = store.state.langSelected.langWsp;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/enroll?lang=${params.lang}`, params);

      store.commit('UPDATE_TOKEN', {
        access_token: resp.data.access_token,
        expirationDate: resp.data.expirationDate,
        expires_in: resp.data.expires_in,
        refresh_token: resp.data.refresh_token,
        roles: resp.data.roles,
        token_type: resp.data.token_type,
        username: resp.data.username
      });

      await sessionService.check(false);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async validatePhone(phoneValidationToken) {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/validatePhone`, { phoneValidationToken });
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  },

  async traceUsername(params) {
    let apiUrl = store.state.countrySelected.api;

    try {
      let resp = await axios.post(`${apiUrl}/${apiPath}/traceUsername`, params);
      return {
        data: resp.data,
        error: false
      };
    } catch (error) {
      return {
        data: error.data,
        error: true
      };
    }
  }
};
